export default __webpack_public_path__ + "static/media/Invoicing.7fec640d.svg";